import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Button } from "./ui/button";
import { 
  ChevronDown, 
  BarChart3, 
  Users, 
  Building2, 
  Settings, 
  LogOut,
  TrendingUp
} from "lucide-react";

const AdminHeaderDropdown = ({ onNavigate, onTabChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    {
      label: "Dashboard Principale",
      icon: BarChart3,
      action: () => onTabChange("overview")
    },
    {
      label: "Gestione Agenzie", 
      icon: Building2,
      action: () => onTabChange("agenzie")
    },
      {
        label: "Gestione Candidati",
        icon: Users,
        action: () => onTabChange("candidati")
      },
    {
      label: "Statistiche Generali",
      icon: TrendingUp,
      action: () => onTabChange("pagamenti")
    },
    {
      label: "Impostazioni Admin",
      icon: Settings,
      action: () => onTabChange("impostazioni")
    },
    {
      separator: true
    },
    {
      label: "Logout",
      icon: LogOut,
      action: () => onNavigate("/"),
      className: "text-red-600 hover:bg-red-50"
    }
  ];

  const handleItemClick = (item) => {
    if (item.action) {
      item.action();
    }
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <Button
        variant="outline"
        className="rounded-2xl border-gray-300 text-gray-700 hover:bg-gray-50 px-4 py-2 flex items-center gap-2"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Settings className="w-4 h-4" />
        <span className="hidden md:inline">Menu Admin</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </Button>

      {isOpen && (
        ReactDOM.createPortal(
          <>
            {/* Backdrop */}
            <div 
              className="fixed inset-0 z-50" 
              onClick={() => setIsOpen(false)}
            />
            {/* Dropdown Menu */}
            <div 
              className="fixed right-8 top-16 bg-white rounded-2xl shadow-xl border border-gray-200 z-[10000] py-2"
              style={{ 
                width: '280px',
                minWidth: '240px',
                left: 'auto',
                right: '2rem',
                top: '4rem',
                transform: 'translateX(0)'
              }}
            >
              {menuItems.map((item, index) => {
                if (item.separator) {
                  return <div key={index} className="h-px bg-gray-200 my-2" />;
                }
                const Icon = item.icon;
                return (
                  <button
                    key={index}
                    onClick={() => handleItemClick(item)}
                    className={`w-full flex items-center gap-3 px-4 py-3 text-left transition-colors min-h-[44px] ${
                      item.className || "text-gray-700 hover:bg-gray-50 active:bg-gray-100"
                    }`}
                    style={{ 
                      touchAction: 'manipulation',
                      WebkitTapHighlightColor: 'transparent'
                    }}
                  >
                    <Icon className="w-4 h-4 flex-shrink-0" />
                    <span className="text-sm font-medium">{item.label}</span>
                  </button>
                );
              })}
            </div>
          </>,
          document.body
        )
      )}
    </div>
  );
};

export default AdminHeaderDropdown;